import { doc, Timestamp, updateDoc, writeBatch } from 'firebase/firestore';
import { db } from '../../../config';
import { firestoreBatchLimit, masterStatus } from '../../../../../constants/enum';
import { getDictionaryMappingsByPatternId } from './read';

// 辞書マッピングを論理削除する（status=99）。物理削除はしない（マスタ照合と同じ思想）。
export const deleteDictionaryMapping = async (
  dictionaryId: string,
  mappingId: string,
): Promise<void> => {
  const mappingRef = doc(db, 'dictionaries', dictionaryId, 'dictionary_mappings', mappingId);
  await updateDoc(mappingRef, { status: masterStatus.deleted, updated_at: Timestamp.now() });
};

/**
 * 指定パターンに紐づく辞書のマッピングを全て論理削除する（#3344）。
 * パターン削除時に、そのパターンで設定されていた辞書変換マッピングも一緒に外す。
 *
 * マスタ側の deleteMasterMappingsByPatternId（#3056）に対応する処理。
 * マスタは物理削除だが、辞書マッピングは単体削除も論理削除なので辞書側の流儀に合わせる。
 * 辞書は Cloud SQL を使わないため Firestore のみで完結する。
 *
 * 全件が同じ更新内容なので writeBatch でまとめる。1件ずつ await すると
 * 途中で失敗したとき一部だけ論理削除された状態で止まる。
 * マッピングが 1 件も無ければ何もしない。
 */
export const deleteDictionaryMappingsByPatternId = async (
  companyId: string,
  patternId: string,
): Promise<void> => {
  const mappings = await getDictionaryMappingsByPatternId(companyId, patternId);
  if (mappings.length === 0) return;

  for (let start = 0; start < mappings.length; start += firestoreBatchLimit) {
    const batch = writeBatch(db);
    for (const mapping of mappings.slice(start, start + firestoreBatchLimit)) {
      batch.update(
        doc(db, 'dictionaries', mapping.dictionary_id, 'dictionary_mappings', mapping.mapping_id),
        { status: masterStatus.deleted, updated_at: Timestamp.now() },
      );
    }
    await batch.commit();
  }
};
